import { Injectable } from '@angular/core';
import { API } from '@aws-amplify/api';
import { NbToastrService } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { APIS } from 'src/app/shared/constants/api-constants';
import { ENVIRONMENT } from 'src/environments/environment';
import { MapRegion, RobotMaps, RobotMapVersion } from '../../../models/qa-models/robot-maps';
import {
  LoadRobotMapRegionsSuccess,
  LoadRobotMapsSuccess,
  LoadRobotMapVersionsSuccess
} from "../redux";

@Injectable({
  providedIn: 'any'
})
export class MapsService {
  /*
    This MapsService relies on a service role
   */

  public maps_api = APIS.MAPS;

  constructor(
    protected store: Store,
    protected toastrService: NbToastrService
  ) {}

  public loadMapsForRobotAmplify(robotId): void {
    // Returns a flattened list of pmap IDs
    API.get(this.maps_api, `/${ENVIRONMENT.name}/maps/${robotId}/pmaps`, {})
      .then((response) => {
        this.toastrService.show(status, 'Fetching Robot Maps Complete', {
          status: 'success'
        });

        const robotMaps = new RobotMaps(robotId, response);
        this.store.dispatch(new LoadRobotMapsSuccess(robotMaps));
      })
      .catch((error) => {
        this.toastrService.show(status, 'Fetching Robot Maps FAILED', {
          status: 'danger'
        });
        console.error(error);
      });
  }

  public loadMapVersionsForRobotAmplify(robotId, pmapId): void {
    // Returns a flattened list of pmap versions
    API.get(this.maps_api, `/${ENVIRONMENT.name}/maps/${robotId}/pmaps/${pmapId}/versions`, {})
      .then((response) => {
        this.toastrService.show(status, 'Fetching Robot Map Versions Complete', {
          status: 'success'
        });

        const rmv = new RobotMapVersion(robotId, pmapId, response);
        this.store.dispatch(new LoadRobotMapVersionsSuccess(rmv));
      })
      .catch((error) => {
        this.toastrService.show(status, 'Fetching Robot Map Versions FAILED', {
          status: 'danger'
        });
        console.error(error);
      });
  }

  public async loadMapRegionsAmplify(robotId, pmapId, pmapVersionId) {
    let regions = [];
    // Returns a flattened list of pmap regions
    await API.get(
      this.maps_api,
      `/${ENVIRONMENT.name}/maps/${robotId}/pmaps/${pmapId}/versions/${pmapVersionId}/regions`,
      {}
    )
      .then((response) => {
        this.toastrService.show(status, 'Fetching Robot Map Regions Complete', {
          status: 'success'
        });

        if (Array.isArray(response)) {
          regions = response.map((r) => new MapRegion(r.id, r.region_type));
          this.store.dispatch(new LoadRobotMapRegionsSuccess(regions));
        }
      })
      .catch((error) => {
        this.toastrService.show(status, 'Fetching Robot Map Regions FAILED', {
          status: 'danger'
        });
        console.error(error);
      });

    return regions;
  }
}
